import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { TDashletGraphOptions } from '../../dashlet-graph.model';
import { createCostComparisonGraphTooltipLabel } from './create-cost-comparison-tooltip-label';

export function generateCostComparisonGraphOptions(
  isExport: boolean,
  workspacesCosts: { [workspaceId: string]: string[] },
): TDashletGraphOptions {
  const fontSize = isExport ? 42 : 12;
  const fontColor = '#586378';
  const fontFamily = getFontFamily();

  return {
    devicePixelRatio: window.devicePixelRatio,
    scales: {
      x: {
        stacked: false,
        ticks: {
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        stacked: false,
        ticks: {
          min: 0,
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
          maxTicksLimit: 7,
        },
        grid: {
          beginAtZero: true,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        onClick: null,
        position: 'top',
        labels: {
          pointStyle: 'circle',
          boxWidth: 10,
          boxHeight: 10,
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            return createCostComparisonGraphTooltipLabel(tooltipItem, workspacesCosts);
          },
        },
      },

      datalabels: {
        display: (value) => false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    cutout: 55,
  };
}
